import { useState, useCallback } from 'react';

function shuffleArray(arr: number[]): number[] {
  const shuffled = [...arr];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

interface UseSecureKeypadOptions {
  maxLength: number;
  onComplete?: (value: string) => void;
}

interface UseSecureKeypadReturn {
  value: string;
  displayValue: string;
  keyLayout: number[];
  handleKeyPress: (digit: number) => void;
  handleDelete: () => void;
  clear: () => void;
}

function useSecureKeypad({ maxLength, onComplete }: UseSecureKeypadOptions): UseSecureKeypadReturn {
  const [value, setValue] = useState('');
  const [keyLayout, setKeyLayout] = useState(() => shuffleArray([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]));

  const handleKeyPress = useCallback((digit: number) => {
    setValue(prev => {
      if (prev.length >= maxLength) return prev;
      const next = prev + String(digit);
      if (next.length === maxLength) onComplete?.(next);
      return next;
    });
  }, [maxLength, onComplete]);

  const handleDelete = useCallback(() => {
    setValue(prev => prev.slice(0, -1));
  }, []);

  const clear = useCallback(() => {
    setValue('');
    setKeyLayout(shuffleArray([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]));
  }, []);

  return {
    value,
    displayValue: '●'.repeat(value.length),
    keyLayout,
    handleKeyPress,
    handleDelete,
    clear,
  };
}

export default useSecureKeypad;
